import {css, StyleSheet} from 'aphrodite';
import React, {useCallback} from 'react';

import WorksheetStepDropdownButton from 'notebook/worksheets/steps//WorksheetStepDropdownButton';
import WorksheetStepButton from 'notebook/worksheets/steps/WorksheetStepButton';
import {WorksheetTaskStatusType} from 'notebook/worksheets/WorksheetConstants';
import {WorksheetContext} from 'notebook/worksheets/WorksheetContext';
import {HasAvatar} from 'ui-library/avatar/Avatar';
import ButtonGroup from 'ui-library/buttons/ButtonGroup';

interface WorksheetStepStatusBadgeProps {
  onSubmit?: (submitOption: WorksheetTaskStatusType) => Promise<void>;
  status: WorksheetTaskStatusType;
  lastEditedUser?: HasAvatar;
  timestamp?: string;
  locked: boolean;
}

/**
 * A component allowing the user to submit a step with a particular
 * status.
 */
export default function WorksheetStepStatusBadge({
  onSubmit,
  status,
  lastEditedUser,
  timestamp,
  locked,
}: WorksheetStepStatusBadgeProps): JSX.Element {
  const {viewer} = WorksheetContext.useContext();
  const callback = useCallback(
    async (submitOption) => {
      if (onSubmit) {
        await onSubmit(submitOption);
      }
    },
    [onSubmit]
  );

  const showWorksheetStepDropdownButton =
    [WorksheetTaskStatusType.READY, WorksheetTaskStatusType.AMENDING].includes(status) && !viewer;

  return (
    <ButtonGroup dataTestAttrs={{component: 'WorksheetStepStatusBadge', element: 'buttonGroup'}}>
      <WorksheetStepButton
        className={css(styles.buttonHeightOverride)}
        onClick={callback}
        status={status}
        lastEditedUser={lastEditedUser}
        timestamp={timestamp}
        locked={locked}
      />
      {showWorksheetStepDropdownButton && (
        <WorksheetStepDropdownButton
          className={css(styles.buttonHeightOverride)}
          onSelect={callback}
          locked={locked}
        />
      )}
    </ButtonGroup>
  );
}

const styles = StyleSheet.create({
  buttonHeightOverride: {
    display: 'flex',
    height: 32,
    alignItems: 'center',
  },
});
